module.exports = __webpack_public_path__ + "img/washer10247.prt.ae30fbe0.jpg";